import gql from "graphql-tag";

export default gql`query FileEvents($id:Int!) {
    file(id:$id) {
        id    
        messages {
            id      
            body       
            origin
            dealt       
            timestamp
            who {
                id
                name
            }
            user {
                id
                name
                typeid
            }
        }
      }
  }`